
import PageLayout from '@/components/layout/PageLayout';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => {
  return (
    <PageLayout>
      <Helmet>
        <title>Privacy Policy | OMAC-UK Taekwondo</title>
        <meta name="description" content="OMAC-UK Taekwondo's privacy policy detailing how we handle your information and protect your privacy." />
      </Helmet>

      {/* Hero Section */}
      <div className="pt-16 pb-12 bg-gray-900 text-white">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold font-display mb-6">Privacy Policy</h1>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto prose prose-lg">
          <p className="text-lg mb-8">Effective Date: 16/03/2025</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Introduction</h2>
          <p>Welcome to OMAC-UK. We respect your privacy and are committed to ensuring your data remains secure. This website is for informational purposes only and does not collect, store, or process personal data.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">2. Compliance with UK Data Protection Laws</h2>
          <p>While we do not collect personal data, we align with the principles of the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018, ensuring transparency in how we manage our website.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Cookies & Tracking</h2>
          <p>We do not use cookies, tracking scripts, analytics tools, or any form of user data collection. Your visit to our website remains completely anonymous.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Security & Website Integrity</h2>
          <p>We take reasonable steps to ensure this website remains secure and free from malicious software. However, users should take appropriate security precautions, such as using antivirus software, to protect their own devices.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">5. External Links</h2>
          <p>Our website may contain links to third-party websites. These external sites operate independently, and we are not responsible for their content, privacy policies, or security practices. We encourage you to review their policies separately.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">6. Intellectual Property & Image Rights</h2>
          <p>All images and content on this website, except those of Byung-Jik Ro, are proprietary and subject to copyright.</p>
          <p>Unauthorised use, reproduction, or distribution of these materials without explicit written consent is strictly prohibited.</p>
          <p>Any unauthorised use may result in legal action.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">7. Changes to This Privacy Policy</h2>
          <p>We reserve the right to update this policy at any time. Changes will be posted on this page, and continued use of the website implies acceptance of the updated terms.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">8. Governing Law</h2>
          <p>This Privacy Policy is governed by the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">9. Contact Us</h2>
          <p>For any privacy concerns or questions, please contact us at <a href="mailto:masterjuliet@omac-uk.co.uk" className="text-taekwondo-red hover:underline">masterjuliet@omac-uk.co.uk</a>.</p>
        </div>
      </div>
    </PageLayout>
  );
};

export default PrivacyPolicy;
